import { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from 'antd';

import { getProofImages, getProofOfFoundImages } from 'services/ops-control';
import { COMMENT_SOURCE } from 'constants/lost-or-damaged';

import { ImageCarousel } from './ImageCarousel/ImageCarousel';
import { notify } from 'components/Notify/Notify';
import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as Close } from 'assets/bosta-icons/Close.svg';

import './ProofModal.less';

const ProofModal = ({ intl, close, delivery, fromFleet, fromHub, ...rest }) => {
  const comments = delivery?.state?.deliveryLossLiability?.comments?.filter(
    (comment) =>
      comment?.source === (fromFleet ? COMMENT_SOURCE.STAR : COMMENT_SOURCE.HUB)
  );

  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchProofImages = async (deliveryId) => {
    setIsLoading(true);
    try {
      const { data } = await (fromHub
        ? getProofOfFoundImages(deliveryId)
        : getProofImages(deliveryId));
      setImages(data);
    } catch (error) {
      setImages([]);
      notify(error.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (delivery?._id) {
      fetchProofImages(delivery?._id);
    }
  }, [delivery?._id]);

  return (
    <Modal
      className="br-lost-orders__proof-modal"
      {...rest}
      title={
        <div className="br-lost-orders__proof-modal__title">
          <span>
            {intl.formatMessage({
              id: 'ops_control.lost_orders.proof_modal.title'
            })}
          </span>
          <BRButton type={'link-gray'} onClick={close} label={<Close />} />
        </div>
      }
      footer={<></>}
      centered
    >
      <div className="br-lost-orders__proof-modal__container">
        <span className="display-xs">Justification</span>
        {comments?.map((comment) => (
          <span className="heading">{comment?.text}</span>
        ))}
        <ImageCarousel isLoading={isLoading} images={images} />
      </div>
    </Modal>
  );
};

export default injectIntl(ProofModal);
